import { render, staticRenderFns } from "./template.vue?vue&type=template&id=7a9dfc06&scoped=true&"
import script from "@/Components/Global/PopupTable/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/PopupTable/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/PopupTable/style.scss?vue&type=style&index=0&id=7a9dfc06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9dfc06",
  null
  
)

export default component.exports